// API configuration — cPanel Node.js setup (no PHP proxy)
//
// Production: Node.js app serves both the React build and /backend/api/*
// Development: CRA proxy in package.json forwards /backend/* to localhost:5000

export const API_BASE = '/backend/api';

export const API_ENDPOINTS = {
  LOGIN: `${API_BASE}/members/login`,

  MEMBERS: `${API_BASE}/members`,
  APPLICATIONS: `${API_BASE}/members/applications`,
  SUBSCRIBERS: `${API_BASE}/members/subscribers`,
  APPROVE: (empNo) => `${API_BASE}/members/approve/${empNo}`,
  UPDATE_APPLICATION: (empNo) => `${API_BASE}/members/applications/${empNo}`,
  UPDATE_MEMBER: (empNo) => `${API_BASE}/members/${empNo}`,
  DELETE_APPLICATION: (empNo) => `${API_BASE}/members/applications/${empNo}`,
  DELETE_MEMBER: (empNo) => `${API_BASE}/members/${empNo}`,
  SEND_APPROVAL_EMAIL: `${API_BASE}/members/email/send-approval`,
  SEND_REMINDERS: `${API_BASE}/members/reminders/send`,
  SEARCH: (query) => `${API_BASE}/members/search?query=${query}`,
  ADD_MEMBER: `${API_BASE}/members/add`,
  REGISTER: `${API_BASE}/members/register`,
  SUBSCRIBE: `${API_BASE}/members/subscribe`,

  TRANSACTIONS: `${API_BASE}/transactions`,
  TRANSACTION_STATS: `${API_BASE}/transactions/stats`,
  UNPAID: `${API_BASE}/transactions/unpaid`,
  DELETE_TRANSACTION: (id) => `${API_BASE}/transactions/${id}`,

  MANUAL_PAYERS: `${API_BASE}/manual-payers`,
  MANUAL_PAYER_STATS: `${API_BASE}/manual-payers/stats`,
  MANUAL_PAYER: (id) => `${API_BASE}/manual-payers/${id}`,
  MANUAL_PAYER_FROM_MEMBER: (empNo) => `${API_BASE}/manual-payers/from-member/${empNo}`,

  UNEMPLOYED_MEMBERS: `${API_BASE}/unemployed-members`,
  UNEMPLOYED_TRANSFER_FROM_MEMBERS: (empNo) => `${API_BASE}/unemployed-members/transfer-from-members/${empNo}`,
  UNEMPLOYED_TRANSFER_TO_MEMBERS: (idNo) => `${API_BASE}/unemployed-members/transfer-to-members/${encodeURIComponent(idNo)}`,

  CDAS: `${API_BASE}/cdas`,
  SCOTT_HOSPITAL: `${API_BASE}/scott-hospital`,

  SYSTEM_HEALTH: `${API_BASE}/system/health`,
  SYSTEM_ANALYTICS: `${API_BASE}/system/analytics`,
  SYSTEM_USERS: `${API_BASE}/system/users`,
  SYSTEM_LOGS: `${API_BASE}/system/logs`,

  PORTAL_LOGIN: `${API_BASE}/portal/login`,
  PORTAL_PERFORMANCE: `${API_BASE}/portal/performance`,
};

if (process.env.NODE_ENV === 'development') {
  console.log('API Base:', API_BASE);
}
